import { render, staticRenderFns } from "./CarpetaCompartida.vue?vue&type=template&id=7549ceac"
import script from "./CarpetaCompartida.vue?vue&type=script&lang=js"
export * from "./CarpetaCompartida.vue?vue&type=script&lang=js"
import style0 from "./CarpetaCompartida.vue?vue&type=style&index=0&id=7549ceac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports